import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { emit } from 'process';
import { first } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ApiService } from 'src/app/api.service';
import { CategoryLan } from 'src/app/shared/models/CategoryLan';
import { CookieTovpil } from 'src/app/shared/models/CookieTovpil';
import { Constants } from 'src/app/shared/vo/Constants';
import { TovpilCrudService } from 'src/app/utils/tovpil-crud-service';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';
import { TovpilLanguageService } from 'src/app/utils/tovpil-language.service';
import { UrlBuilderService } from 'src/app/utils/tovpil-url-builder.service';
import { UserPreferencesService } from 'src/app/utils/user-preferences.service';


@Component({
  selector: 'app-material-movements',
  templateUrl: './loc-mat-ctl.component.html',
  styleUrls: ['./loc-mat-ctl.component.scss'],
  providers: [MessageService, ConfirmationService, TovpilLanguageService]
})
export class LocMatCtlLstComponent implements OnInit {

  /** USER PREFERENCES */
  globalUserPreferences: CookieTovpil = {};
  globalUserDataForm: FormGroup;

  /** COMPONENT */
  languages: any[];
  periods: any[];
  currencies: any[];
  guides: CategoryLan[];
  stores: any[];
  entryTypes: any[] = ['S', 'E'];
  isAvailable : boolean = true;

  /** PIPES */
  datePipe: DatePipe = new DatePipe('en-US');

  /** LABELS */
  translations: Record<string, string> = null;
  lbl_monday: string;
  lbl_tuesday: string;
  lbl_wednesday: string;
  lbl_thursday: string;
  lbl_friday: string;
  lbl_saturday: string;
  lbl_sunday: string;

  /** COMPONENT OVERLAY */
  blocked: boolean = true;

  /** DATAPARENT */
  dataParent: any = {};

  /** ENDPOINTS */
  endPointLanguageByStoreId = "getListSpkLangByStoreId";
  endPointPriceExchangeRate = "findMaxExchangeRate";
  endPointGetValidPeriods = "getValidPeriods";
  endPointGetCurrencyByStoreId = "getListCurrencyByStoreId";
  endPointGetStoreById = "getStoreById";
  endPointListDependentLocalStores = "listDependetLocalStores";
  endPointGetGuidesByYearAndPeriod = "getGuidesByYearAndPeriod";
  endPointGetLoadServs = "getLoadServs";
  endPointGetLoadAmount = "getLoadAmount"
  endPointGetLoadSales = "getSalesCons"
  endPointSavePendAmount = "savePendAmount";
  endPointGetCategotyLang = "getCategoryLang";
  endPointGetListDetailGuidesMat = "getListDetailGuidesMat";

  /** SALES ELEMENTS */
  dataSales: Record<string, any>[];
  colsSales: any[];
  rowsSales: number = 8;
  colsGlSales = ['guideId', 'guideName', 'guideLastName', 'saldoAnt', 'impPerio', 'paymeDie', 'impPendi'];
  colsFiSales = [
    { name: 'lbl_guideId', value: 'guideId' },
    { name: 'lbl_name', value: 'guideName' },
    { name: 'lbl_lastname', value: 'guideLastName' },
    { name: 'lbl_previous_balance', value: 'saldoAnt' },
    { name: 'lbl_period_amount', value: 'impPerio' },
    { name: 'lbl_period_die_payment', value: 'paymeDie' },
    { name: 'lbl_pending_amount', value: 'impPendi' }
  ];

  /** GUIDE ELEMENTS */
  dataGuide: Record<string, any>[];
  colsGuide: any[];
  rowsGuide: number = 8;
  colsGlGuide = ['guideId', 'name', 'lastName', 'shrName'];
  colsFiGuide = [
    { name: 'lbl_id', value: 'guideId' },
    { name: 'lbl_type' , value: 'guiType'},
    { name: 'lbl_name', value: 'name' },
    { name: 'lbl_last_name', value: 'lastName' },
    // { name: 'lbl_short_Name', value: 'shrName' },
  ];

  /** SERVICES ELEMENTS */
  dataServ: Record<string, any>[];
  colsServ: any[];
  rowsServ: number = 5;
  colsGlServ = ['wkrsId', 'guiType', 'serTyp', 'chrName', 'chrAddress', 'strDate', 'weekDays', 'weekTime', 'chrVicar', 'chrDecan', 'name'];
  colsFiServ = [
    { name: 'lbl_id', value: 'wkrsId' },
    { name: 'lbl_name', value: 'name' },
    { name: 'lbl_type', value: 'serTyp' },
    { name: 'lbl_churchs_chapels_parish', value: 'chrName' },
    { name: 'lbl_address', value: 'chrAddress' },
    { name: 'lbl_starting_date', value: 'strDate' },
    { name: 'lbl_day', value: 'weekDays' },
    { name: 'lbl_hour', value: 'weekTime' },
    { name: 'lbl_vicarage', value: 'chrVicar' },
    { name: 'lbl_deanery', value: 'chrDecan' },
  ];

  /** AMOUNT ELEMENTS */
  dataAmount: Record<string, any>[];
  colsAmount: any[];
  rowsAmount: number = 8;
  colsGlAmount = ['guideId', 'name', 'year', 'wrksId', 'status', 'entryType', 'ordGuiSts', 'currDate', 'packNum', 'material'];
  colsFiAmount = [
    { name: 'lbl_guideId', value: 'guideId' },
    { name: 'lbl_name', value: 'name' },
    { name: 'lbl_year', value: 'year' },
    { name: 'lbl_workshopId', value: 'wrksId' },
    { name: 'lbl_type', value: 'entryType' },
    { name: 'lbl_status', value : 'ordGuiSts'},
    { name: 'lbl_date', value: 'currDate' },
    { name: 'lbl_quantity', value: 'packNum' },
    { name: 'lbl_amount', value: 'material' },
  ];


  /** GUIDE ELEMENTS */
  dataDetailGuide: Record<string, any>[];
  colsDetailGuide: any[];
  rowsDetailGuide: number = 8;
  colsGlDetailGuide = ['itemId', 'itemDescrip', 'currDate', 'guiName', 'docType', 'qty'];
  colsFiDetailGuide = [
    { name: 'lbl_id', value: 'itemId' },
    { name: 'lbl_item_id', value: 'itemDescrip' },
    { name: 'lbl_starting_date', value: 'currDate' },
    { name: 'lbl_name', value: 'guiName' },
    { name: 'lbl_type', value: 'docType' },
    { name: 'lbl_quantity', value: 'qty' },
  ];

  /** VIEW FILTERS */
  @ViewChild('dt1') private tableSales: Table;
  @ViewChild('dt2') private tableGuideCoord: Table;
  @ViewChild('dt3') private tableServices: Table;
  @ViewChild('dt4') private tableAmount: Table;
  @ViewChild('dt5') private tableItemsRequested: Table;


  /**
   * This constructor function initializes various services and variables used in the component, and also
   * checks for authentication based on the token and device parameters passed in the URL.
   * @param {MessageService} messageService - This parameter is of type MessageService and is used for
   * displaying messages to the user. It is likely used to show success or error messages during certain
   * operations.
   * @param {ConfirmationService} confirmationService - The `confirmationService` is a service that
   * provides methods for displaying confirmation dialogs to the user. It is used to prompt the user for
   * confirmation before performing certain actions.
   * @param {ApiService} apiService - An instance of the ApiService class, which is responsible for
   * making API requests and handling responses.
   * @param {ActivatedRoute} route - The `route` parameter is an instance of the `ActivatedRoute` class,
   * which is used to access the current route's information. It provides access to the route's
   * parameters, query parameters, and other related data. In this code snippet, the `route` parameter is
   * used to subscribe to the
   * @param {AuthenticationService} authenticationService - This parameter is used to authenticate the
   * user and manage user authentication-related tasks, such as logging in, logging out, and retrieving
   * the current user's information.
   * @param {TovpilFilesService} filesService - The `filesService` parameter is an instance of the
   * `TovpilFilesService` class. It is used to handle file-related operations, such as uploading and
   * downloading files.
   * @param {TovpilCrudService} tovpilCrudService - The `tovpilCrudService` parameter is an instance of
   * the `TovpilCrudService` class. It is used to perform CRUD (Create, Read, Update, Delete) operations
   * on data in the application.
   * @param {FormBuilder} fb - The `fb` parameter is an instance of the `FormBuilder` class. It is used
   * to create instances of `FormGroup` and `FormControl` for building reactive forms in Angular.
   */
  constructor(private messageService: MessageService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private tovpilCrudService: TovpilCrudService,
    private fb: FormBuilder,
    private filesService: TovpilFilesService,
    private userPreferencesService: UserPreferencesService,
    private router: Router,
    private urlBuilderService: UrlBuilderService,
    private translationService: TovpilLanguageService) {

    this.createDataForm();
    this.initConfigs();

    this.route.queryParams.subscribe(params => {
      // Asigna los valores de queryParams a las propiedades de dataParent
      this.dataParent.type = params.type;
    });

    // SE OBTUVIERON PREFERENCIAS EN INIT CONFIG
    const user = this.globalUserPreferences.preferences;
    const currentUser = this.authenticationService.currentUserValue;
    const securitySelected = this.globalUserPreferences;

    if (securitySelected?.tokenProfile && user && user.device === "2") {
      this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
    } else {
      //this.globalUserPreferences.preferences.currentUser = currentUser;
    }
  }

  /**
  * The function initializes form groups for configuration and data, and updates the configuration form
  * with query parameters from the route.
  */
  async initConfigs() {
    // CONSULTAMOS COOKIES
    this.globalUserPreferences = await this.userPreferencesService.getSantovTovpilCookie() || null;
    //console.debug("CX3 RCM - USER PREFERENCES: " + JSON.stringify(this.globalUserPreferences, null, 2));
  }

  /**
  * The function `createDataForm` in TypeScript initializes a form group with various form controls and
  * default values, as well as setting some controls as disabled.
  */
  createDataForm() {
    this.globalUserDataForm = this.fb.group({
      selectedLanguage: new FormControl({ value: null, disabled: false }),
      selectedPeriod: new FormControl({ value: null, disabled: false }),
      selectedCurrency: new FormControl({ value: null }),
      selectedGuide: new FormControl({ value: null, disabled: false }),
      selectedStore: new FormControl({ value: null, disabled: false }),

      selectedCoordination: new FormControl({ value: null, disabled: true }),
      selectedCoordinationLevelId: new FormControl({ value: null, disabled: true }),
    });

    this.getConfigs();
  }

  /**
   * The function `getConfigs()` logs the values of `configForm` and `dataForm` in a formatted JSON
   * string.
   */
  getConfigs() {
    //console.debug("CX3 RCM - REACTIVE FORM: " + JSON.stringify(this.globalUserDataForm.value, null, 2));
  }

  /**
   * The ngOnInit function initializes the component by setting the currentUser property to the current
   * user value from the authentication service and calling the getSecurity function.
   */
  ngOnInit(): void {
    const currentUser = this.authenticationService.currentUserValue;
    //this.globalUserPreferences.preferences.currentUser = currentUser;
    this.getSecurity();
  }

  async getAutOpts(storeId){
    let res = await this.apiService.getAuthorityOptsById({
      "transaction": "CXC3",
      "storeId" : storeId
    });

    if(res.onMaint == '1'){
      this.isAvailable = false;
    }else if(res.onMaint == '0'){
      this.isAvailable = true;
    }
  };

  /**
   * The function `autenthicateByZuul` authenticates a user by calling the `login` method of the
   * `authenticationService` and performs additional actions based on the response.
   * @param {string} user - The `user` parameter is a string that represents the username or user
   * identifier for authentication.
   * @param {string} password - The password parameter is a string that represents the user's password.
   */
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.getSecurity();
          } else {
            //this.messageService.add({ severity: 'warn', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
          }
        },
        error => {
          //this.messageService.add({ severity: 'warn', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
        });
  }

  /**
   * The function `getSecurity()` retrieves security data and performs additional actions if the data is
   * not already available.
   */
  async getSecurity() {
    const securityControl = this.globalUserPreferences || null;

    // ACTUALIZAMOS SEGURIDAD NUEVAMENTE Y TENTATIVAMENTE SE PUEDE ELIMINAR ESTOS BLOQUES
    if (!securityControl) {
      const tokenProfile = this.globalUserPreferences?.tokenProfile || null;
      const data = await this.apiService.findSecurityById({ id: tokenProfile });
      this.globalUserPreferences = data;
    }

    this.getTranslatedLabels();
  }

  /**
   * The function `getTranslatedLabels` is an asynchronous function that retrieves translated labels from
   * a translation service and sets them in the `translations` variable, and then calls another function
   * .
   */
  async getTranslatedLabels() {
    const language = this.globalUserPreferences?.preferences?.language || null;
    const region = this.globalUserPreferences?.preferences?.region || null;

    try {
      await this.translationService.getTranslatedLabels(language, region);

      this.colsFiGuide = this.translationService.translateCols(this.colsFiGuide);
      this.colsFiServ = this.translationService.translateCols(this.colsFiServ);
      this.colsFiAmount = this.translationService.translateCols(this.colsFiAmount);
      this.colsFiSales = this.translationService.translateCols(this.colsFiSales);
      this.colsFiDetailGuide = this.translationService.translateCols(this.colsFiDetailGuide);

      this.translations = this.translationService.getLabels();

      await this.getLanguages();
    } catch (error) {
      console.error("An error occurred while getting translated labels:", error);
      // this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}` });
    }
  }

  /**
   * The function asynchronously fetches store data and updates the global user data
   * form with the retrieved information.
   * @returns The function returns a boolean value (`true` or `false`) based on the
   * success of fetching store data and updating the `selectedCoordination` value in the
   * `globalUserDataForm`. If the store data is successfully fetched, it returns `true`. If there is an
   * error during the process, it returns `false`.
   */
  async getCoordination(storeId: string) {
    try {

      if (!storeId) {
        //console.warn('Missing required parameters: storeId and languageId are necessary.');
        return false;
      }

      const result = await this.tovpilCrudService.fetch(this.endPointGetStoreById, {
        storeId
      });

      if (result.success) {

        this.globalUserDataForm.patchValue({
          selectedCoordination: result.data?.storeId + ' ' + result.data?.descri,
          selectedCoordinationLevelId: result.data?.type ?? ''
        });
        return true;
      } else {
        console.error("An error occurred while fetching coordination");
        // this.handleError(this.translations.lbl_resource_not_found + ': ' + this.translations.lbl_coordination);
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The function is an asynchronous function that fetches a list of languages and handles
   * any errors that occur during the process.
   */
  async getLanguages() {
    //console.debug("CX3 RCM - LANGUAGES");

    const language = this.globalUserPreferences?.preferences?.language || null;
    const storeId = this.globalUserPreferences?.preferences?.coordinationId || null;

    try {
      await this.getAutOpts(storeId);
      const result = await this.tovpilCrudService.fetch(this.endPointLanguageByStoreId, { language, storeId });

      if (result.success) {
        this.languages = result.data;

        if (language && storeId) {
          let selectedLanguage = this.languages.find(o => o.valueId === language);

          // NO EXISTE PARA ESA COORDINACION EL SELECCIONADO
          if (selectedLanguage == null && this.languages.length > 0) {
            selectedLanguage = this.languages[0];
          }

          this.globalUserDataForm.patchValue({
            selectedLanguage: selectedLanguage
          });

          await this.getInitData();
        }
      } else {
        console.error("An error occurred while fetching languages:", result);
        //this.messageService.add({ severity: 'warn', summary: this.translations.lbl_resource_not_found , detail: this.translations.lbl_language });
      }
    } catch (error) {
      console.error("An error occurred while fetching languages:", error);
      // this.messageService.add({ severity: 'warn', summary: this.translations.lbl_resource_not_found , detail: this.translations.lbl_language });
    }
  }

  /**
   * The  function fetches valid periods from a service and assigns them to a list, then
   * selects a default period and returns a boolean indicating success.
   * @returns a boolean value. It returns true if the data retrieval is successful (data.success is
   * true), and false if there is an error or the data retrieval is not successful.
   */
  async getValidPeriods(language: string) {
    try {

      const data = await this.tovpilCrudService.fetch(this.endPointGetValidPeriods, language);

      if (!data.success) {
        //this.handleError('FII List', 'Hubo un problema al procesar los periodos. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        return false;
      }
      const lstPeriod = data.data || []; // Handle empty data array

      const selPeriod = this.globalUserPreferences?.preferences?.periodSelected ?? null;

      const selectedPeriod = selPeriod?.year
        ? lstPeriod.find(period => period.year === selPeriod.year && period.period === selPeriod.period)
        : lstPeriod[0]; // Default to first period if no selection or year missing

      this.periods = lstPeriod;

      this.globalUserDataForm.patchValue({
        selectedPeriod: selectedPeriod
      });

      return true;
    } catch (error) {
      console.error("Error in getValidPeriods:", error);
      // this.messageService.add({ severity: 'warn', summary: this.translations.lbl_resource_not_found , detail: this.translations.period });
      return false;
    }
  }

  /**
    * This TypeScript function asynchronously fetches a list of currencies based on store ID and language
    * ID, handling errors and returning the data if successful.
    * @returns The function returns either the fetched currency data if
    * successful, or `null` if there are missing parameters, an error occurred during fetching, or an
    * exception was caught.
    */
  async getListCurrencyByStoreId(storeId: string, language: string, currency: string) {
    try {

      if (!storeId || !language) {
        //console.warn('Missing required parameters: storeId and languageId are necessary.');
        return false;
      }

      const result = await this.tovpilCrudService.fetch(this.endPointGetCurrencyByStoreId, {
        storeId,
        language: language,
      });

      if (result.success) {
        let lstCurrencies = result.data;

        let currencySelected = currency ? lstCurrencies.find(o => o.valueId === currency) ?? lstCurrencies[0] : lstCurrencies[0] ?? null;
        this.currencies = lstCurrencies;

        this.globalUserDataForm.patchValue({
          selectedCurrency: currencySelected
        });
        return true;
      } else {
        console.error("An error occurred while fetching List Currency by Store");
        // this.messageService.add({ severity: 'warn', summary: this.translations.lbl_resource_not_found , detail: this.translations.lbl_list + " " + this.translations.lbl_currency });
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The function `getGuideTypes` is an asynchronous function that fetches local stores data based on
   * certain parameters and returns a boolean value indicating the success of the operation.
   * @returns a boolean value. It returns true if the data retrieval is successful (data.success is
   * true), and false if there is an error or the data retrieval is not successful.
   */
  async getGuideTypes() {
    try {

      const language = this.globalUserPreferences?.preferences?.language || null;


      const data = await this.tovpilCrudService.fetch(this.endPointGetCategotyLang, {
        fieldId: "guiType",
        language: language
      });

      if (!data.success) {
        this.messageService.add({ severity: 'warn', summary: this.translations.lbl_resource_not_found, detail: this.translations.lbl_type + ", " + this.translations.lbl_guide });
        return false;
      }

      const guideTypeLst = data.data || []; // Handle empty data array

      const selGuideTypeLst = this.dataParent.type ?? (this.globalUserDataForm.get('selectedGuide').value)?.fieldVal ?? null;

      const selectedGuideType = selGuideTypeLst
        ? guideTypeLst.find(guideTyp => guideTyp.fieldVal === selGuideTypeLst)
        : guideTypeLst[0]; // Default to first period if no selection or year missing

      this.guides = guideTypeLst;

      this.globalUserDataForm.patchValue({
        selectedGuide: selectedGuideType
      });

      this.filterDataGuideType();
      return true;
    } catch (error) {
      console.error("Error in getGuideTypes:", error);
      //this.handleError('FII List', 'Hubo un problema al procesar los periodos. Por favor, recargue la página e inténtelo nuevamente más tarde.');
      return false;
    }
  }

  /**
   * The function `getLocalStores` is an asynchronous function that fetches local stores data based on
   * certain parameters and returns a boolean value indicating the success of the operation.
   * @returns a boolean value. It returns true if the data retrieval is successful (data.success is
   * true), and false if there is an error or the data retrieval is not successful.
   */
  async getLocalStores() {
    try {

      const period = this.globalUserPreferences?.preferences?.periodSelected?.period || null;
      const year = this.globalUserPreferences?.preferences?.periodSelected?.year || null;
      const coordinationStoreId = this.globalUserPreferences?.preferences?.coordinationId || null;

      const data = await this.tovpilCrudService.fetch(this.endPointListDependentLocalStores, {
        storeId: coordinationStoreId,
        period: period,
        year: year
      });

      if (!data.success) {
        //this.handleError('FII List', 'Hubo un problema al procesar los periodos. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        return false;
      }

      const lstStore = data.data || []; // Handle empty data array

      const selStore = this.globalUserDataForm.get('selectedStore').value ?? null;

      const selectedStore = selStore
        ? lstStore.find(store => store.storeId === selStore.storeId)
        : lstStore[0]; // Default to first period if no selection or year missing

      this.stores = lstStore;

      this.globalUserDataForm.patchValue({
        selectedStore: selectedStore
      });

      return true;
    } catch (error) {
      console.error("Error in getLocalStores:", error);
      //this.handleError('FII List', 'Hubo un problema al procesar los periodos. Por favor, recargue la página e inténtelo nuevamente más tarde.');
      return false;
    }
  }

  /**
   * The function `filterDataGuideType` filter list data depending selected guide type
   * @returns The `filterDataGuideType()` function is returning a boolean value. It checks if the `year`
   * the current month). If both conditions are met
   */
  filterDataGuideType() {
    if (this.globalUserDataForm.get('selectedGuide').value) {
      // this.tableGuideCoord.filter(this.globalUserDataForm.get('selectedGuide').value.fieldVal, "guiType", "equals");
      // this.tableSales.filter(this.globalUserDataForm.get('selectedGuide').value.fieldVal, "guiType", "equals");
      // this.tableServices.filter(this.globalUserDataForm.get('selectedGuide').value.fieldVal, "guiType", "equals");
      // this.tableAmount.filter(this.globalUserDataForm.get('selectedGuide').value.fieldVal, "guiType", "equals");

    } else {
      // this.tableGuideCoord.clear();
      // this.tableSales.clear();
      // this.tableServices.clear();
      // this.tableAmount.clear();
    }
  }

  filterDataAndRefresh() {
    // this.filterDataGuideType();
    // this.onChangeUserPreferences();
  }
  /**
   * The `getInitData` function fetches price list data, selected price data, and exchange rate data,
   * and then updates the form with the fetched data.
   */
  async getInitData() {
    try {
      const language = this.globalUserPreferences?.preferences?.language || null;
      const currency = this.globalUserPreferences?.preferences?.selCurrency || null;
      const coordinationStoreId = this.globalUserPreferences?.preferences?.coordinationId || null;


      const validPeriodsResponse = await this.getValidPeriods(language);
      const validCurrencyResponse = await this.getListCurrencyByStoreId(coordinationStoreId, language, currency);
      const validCoordinationResponse = await this.getCoordination(coordinationStoreId);
      const validLocalResponse = await this.getLocalStores();
      const validGuideTypes = await this.getGuideTypes();

      if (validPeriodsResponse && validCurrencyResponse && validCoordinationResponse && validLocalResponse && validGuideTypes) {

        this.getConfigs();
        await this.loadData();
      } else {
        console.error("An error occurred while fetching price list:", validPeriodsResponse);
        //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
      }
    } catch (error) {
      console.error("An error occurred while fetching price list:", error);
      //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
    }
  }

  /**
 * The `loadData` function is an asynchronous function that loads data from an API and displays a
 * message based on the validity of the form data.
 * @returns nothing.
 */
  async loadData() {
    if (!this.globalUserDataForm.valid) {
      return;
    }

    try {
      this.blocked = true;

      // Ejecutar las peticiones en paralelo
      const [guidesResponse, 
        servsResponse, amountResponse, listDetailResponse
      ] = await Promise.all([
        this.getListGuide(),
        this.getListServs(),
        this.getListAmount(),
        //--- this.getListSales(),
        this.getListGuideDetail()
      ]);

      // Verifica si todas las respuestas son válidas
      if (guidesResponse 
        && servsResponse && amountResponse && listDetailResponse
      ) {
        this.blocked = false;
      } else {
        this.blocked = false;
      }
    } catch (error) {
      console.error(error);
      this.blocked = false;
    } finally {
      setTimeout(() => {
        // Si es necesario realizar alguna acción después de esperar
      }, 1500);
    }
  }

  /**
   * The function `reloadGetListServs` asynchronously reloads a list of services, displaying an error
   * message if the operation fails.
   */
  async reloadGetListServs() {
    try {
      this.blocked = true;
      const servsResponse = await this.getListServs();
      if (servsResponse) {
        this.blocked = false;
      } else {
        console.error("Error recargando list serve");
        this.messageService.add({ severity: 'warn', summary: this.translations.lbl_reload_error, detail: this.translations.lbl_try_again });
        this.blocked = false;
      }
    } catch (error) {
      console.error(error);
      this.blocked = false;
      console.error("Error recargando list serve");
      this.messageService.add({ severity: 'warn', summary: this.translations.lbl_reload_error, detail: this.translations.lbl_try_again });
    } finally {
      setTimeout(() => {
      }, 1500);
    }
  }

  /**
   * The function `reloadGetListGuide` asynchronously reloads a list of guides, displaying an error
   * message if the operation fails.
   */
  async reloadGetListGuide() {
    try {
      this.blocked = true;
      const servsResponse = await this.getListGuide();
      if (servsResponse) {
        this.blocked = false;
      } else {
        console.error("Error recargando list guide");
        this.messageService.add({ severity: 'warn', summary: this.translations.lbl_error + ' ' + this.translations.lbl_reload, detail: this.translations.lbl_try + ' ' + this.translations.lbl_again });
        this.blocked = false;
      }
    } catch (error) {
      console.error(error);
      this.blocked = false;
      console.error("Error recargando list guide");
      this.messageService.add({ severity: 'warn', summary: this.translations.lbl_error + ' ' + this.translations.lbl_reload, detail: this.translations.lbl_try + ' ' + this.translations.lbl_again });
    } finally {
      setTimeout(() => {
      }, 1500);
    }
  }

  /**
   * This TypeScript function asynchronously reloads a list amount and handles any errors that may occur.
   */
  async reloadGetListAmount() {
    try {
      this.blocked = true;
      const servsResponse = await this.getListAmount();
      if (servsResponse) {
        this.blocked = false;
      } else {
        console.error("Error recargando list amount");
        this.messageService.add({ severity: 'warn', summary: this.translations.lbl_error + ' ' + this.translations.lbl_reload, detail: this.translations.lbl_try + ' ' + this.translations.lbl_again });
        this.blocked = false;
      }
    } catch (error) {
      console.error(error);
      this.blocked = false;
      console.error("Error recargando list amount");
      this.messageService.add({ severity: 'warn', summary: this.translations.lbl_error + ' ' + this.translations.lbl_reload, detail: this.translations.lbl_try + ' ' + this.translations.lbl_again });
    } finally {
      setTimeout(() => {
      }, 1500);
    }
  }

  /**
   * The function asynchronously reloads a list of sales data, displaying an error
   * message if the operation fails.
   */
  async reloadGetListSales() {
    try {
      this.blocked = true;
      const servsResponse = await this.getListSales();
      if (servsResponse) {
        this.blocked = false;
      } else {
        console.error("Error recargando list sales");
        this.messageService.add({ severity: 'warn', summary: this.translations.lbl_error + ' ' + this.translations.lbl_reload, detail: this.translations.lbl_try + ' ' + this.translations.lbl_again });
        this.blocked = false;
      }
    } catch (error) {
      console.error(error);
      this.blocked = false;
      console.error("Error recargando list sales");
      this.messageService.add({ severity: 'warn', summary: this.translations.lbl_error + ' ' + this.translations.lbl_reload, detail: this.translations.lbl_try + ' ' + this.translations.lbl_again });
    } finally {
      setTimeout(() => {
      }, 1500);
    }
  }

  /**
 * The function `reloadGetGuideDetail` asynchronously reloads a list of sales data, displaying an error
 * message if the operation fails.
 */
  async reloadGetGuideDetail() {
    try {
      this.blocked = true;
      const servsResponse = await this.getListGuide();
      if (servsResponse) {
        this.blocked = false;
      } else {
        console.error("Error recargando guide detail");
        this.messageService.add({ severity: 'warn', summary: this.translations.lbl_error + ' ' + this.translations.lbl_reload, detail: this.translations.lbl_try + ' ' + this.translations.lbl_again });
        this.blocked = false;
      }
    } catch (error) {
      console.error(error);
      this.blocked = false;
      console.error("Error recargando guide detail");
      this.messageService.add({ severity: 'warn', summary: this.translations.lbl_error + ' ' + this.translations.lbl_reload, detail: this.translations.lbl_try + ' ' + this.translations.lbl_again });
    } finally {
      setTimeout(() => {
      }, 1500);
    }
  }

  /**
   * The function `getListServs` is an asynchronous function that fetches a list of services and handles
   * the success and error cases.
   * @returns a Promise.
   */
  async getListServs() {
    try {
      const selLanguage = this.globalUserPreferences?.preferences?.language || null;
      const selPeriod = this.globalUserPreferences?.preferences?.periodSelected?.period || null;
      const selYear = this.globalUserPreferences?.preferences?.periodSelected?.year || null;
      const selStoreId = this.globalUserPreferences?.preferences?.coordinationId || null;

      let req = {
        storeId: selStoreId,
        period: selPeriod,
        year: selYear,
        language: selLanguage,
      };

      return new Promise((resolve, reject) => {
        this.tovpilCrudService.fetch(this.endPointGetLoadServs, req).then(result => {
          //console.debug("CX3 RCM - SERVS: ", req, result)
          if (result.success) {
            this.handleSuccessLstServe(result.data);
            resolve(true);
          } else {
            console.error("An error occurred while fetching list servs");
            this.handleError(this.translations.lbl_no + ' ' + this.translations.lbl_information + ' ' + this.translations.lbl_to + ' ' + this.translations.lbl_process + ", " + this.translations.lbl_try + ' ' + this.translations.lbl_again);
            resolve(false);
          }
        }).catch(error => {
          console.error(error);
          reject(error);
        });
      });
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The function `getListGuide` is an asynchronous function that fetches a list of guides based on the
   * selected store, period, and year, and handles the success and error cases accordingly.
   * @returns a Promise.
   */
  async getListGuide() {
    try {

      const selPeriod = this.globalUserPreferences?.preferences?.periodSelected?.period || null;
      const selYear = this.globalUserPreferences?.preferences?.periodSelected?.year || null;
      const selStoreId = this.globalUserPreferences?.preferences?.coordinationId || null;

      let req = {
        storeId: selStoreId,
        period: selPeriod,
        year: selYear,
      };

      return new Promise((resolve, reject) => {
        this.tovpilCrudService.fetch(this.endPointGetGuidesByYearAndPeriod, req).then(result => {
          //console.debug("CX3 RCM - GUIDE: ", req, result)
          if (result.success) {
            this.handleSuccessLstGuide(result.data);
            resolve(true);
          } else {
            console.error("An error occurred while fetching purchase order data:");
            this.handleError(this.translations.lbl_no + ' ' + this.translations.lbl_information + ' ' + this.translations.lbl_to + ' ' + this.translations.lbl_process + ", " + this.translations.lbl_try + ' ' + this.translations.lbl_again);
            resolve(false);
          }
        }).catch(error => {
          console.error(error);
          reject(error);
        });
      });
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The function `getListAmount` is an asynchronous function that fetches data from an API endpoint and
   * handles the success and error cases.
   * @returns a Promise.
   */
  async getListAmount() {
    try {

      const selPeriod = this.globalUserPreferences?.preferences?.periodSelected?.period || null;
      const selYear = this.globalUserPreferences?.preferences?.periodSelected?.year || null;
      const selStoreId = this.globalUserPreferences?.preferences?.coordinationId || null;
      const selLanguage = this.globalUserPreferences?.preferences?.language || null;

      let req = {
        storeId: selStoreId,
        period: selPeriod,
        year: selYear,
        language: selLanguage
      };

      return new Promise((resolve, reject) => {
        this.tovpilCrudService.fetch(this.endPointGetLoadAmount, req).then(result => {
          //console.debug("CX3 RCM - AMOUNT: ", req, result);
          if (result.success) {
            this.handleSuccessLstAmount(result.data);
            resolve(true);
          } else {
            console.error("An error occurred while fetching purchase order data:");
            this.handleError(this.translations.lbl_no + ' ' + this.translations.lbl_information + ' ' + this.translations.lbl_to + ' ' + this.translations.lbl_process + ", " + this.translations.lbl_try + ' ' + this.translations.lbl_again);
            resolve(false);
          }
        }).catch(error => {
          console.error(error);
          reject(error);
        });
      });
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The function `getListSales` is an asynchronous function that fetches a list of sales data and
   * handles success and error cases.
   * @returns a Promise object.
   */
  async getListSales() {
    try {

      const selPeriod = this.globalUserPreferences?.preferences?.periodSelected?.period || null;
      const selYear = this.globalUserPreferences?.preferences?.periodSelected?.year || null;
      const selStoreId = this.globalUserPreferences?.preferences?.coordinationId || null;

      let req = {
        storeId: selStoreId,
        period: selPeriod,
        year: selYear,
      };

      return new Promise((resolve, reject) => {
        this.tovpilCrudService.fetch(this.endPointGetLoadSales, req).then(result => {
          //console.debug("CX3 RCM - SALES: ", req, result)
          if (result.success) {
            this.handleSuccessLstSales(result.data);
            resolve(true);
          } else {
            console.error("An error occurred while fetching purchase order data:");
            this.handleError(this.translations.lbl_no + ' ' + this.translations.lbl_information + ' ' + this.translations.lbl_to + ' ' + this.translations.lbl_process + ", " + this.translations.lbl_try + ' ' + this.translations.lbl_again);
            resolve(false);
          }
        }).catch(error => {
          console.error(error);
          reject(error);
        });
      });
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The function `getListGuideDetail` is an asynchronous function that fetches data from an API endpoint and
   * handles the success and error cases.
   * @returns a Promise.
   */
  async getListGuideDetail() {
    try {

      const selPeriod = this.globalUserPreferences?.preferences?.periodSelected?.period || null;
      const selYear = this.globalUserPreferences?.preferences?.periodSelected?.year || null;
      const selStoreId = this.globalUserPreferences?.preferences?.coordinationId || null;
      const selLanguage = this.globalUserPreferences?.preferences?.language || null;

      let req = {
        storeId: selStoreId,
        period: selPeriod,
        year: selYear,
        language: selLanguage
      };

      return new Promise((resolve, reject) => {
        this.tovpilCrudService.fetch(this.endPointGetListDetailGuidesMat, req).then(result => {
          //console.debug("CX3 RCM - GUIDE DETAIL: ", req, result);
          if (result.success) {
            this.handleSuccessLstGuideDetail(result.data);
            resolve(true);
          } else {
            console.error("An error occurred while fetching purchase order data:");
            this.handleError(this.translations.lbl_no + ' ' + this.translations.lbl_information + ' ' + this.translations.lbl_to + ' ' + this.translations.lbl_process + ", " + this.translations.lbl_try + ' ' + this.translations.lbl_again);
            resolve(false);
          }
        }).catch(error => {
          console.error(error);
          reject(error);
        });
      });
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The function "handleSuccessLstGuideDetail" handles the success response of a data retrieval operation and
   * updates the necessary variables and properties accordingly.
   * @param {any[]} data - An array of objects containing the data to be processed.
   */
  async handleSuccessLstGuideDetail(data: any[]) {
    if (data.length > 0) {
      // Extraer dinámicamente las columnas del JSON
      this.colsDetailGuide = this.tovpilCrudService.extractColumns(data[0], undefined, this.colsFiDetailGuide);
      // Asignar los datos al arreglo de productos
      this.dataDetailGuide = data;
      // Asignar el número de filas por página dinámicamente
      this.rowsAmount = this.tovpilCrudService.calculateRowsPerPage(data.length, this.rowsDetailGuide);
    } else {
      this.dataDetailGuide = null;
      this.colsDetailGuide = null;
      //this.handleError("Hubo un problema, no hay información que procesar en lista de guias. Por favor, recargue la página e inténtelo nuevamente más tarde.");
    }
  }

  /**
   * The function "handleSuccessLstAmount" handles the success response of a data retrieval operation and
   * updates the necessary variables and properties accordingly.
   * @param {any[]} data - An array of objects containing the data to be processed.
   */
  async handleSuccessLstAmount(data: any[]) {
    if (data.length > 0) {
      // Extraer dinámicamente las columnas del JSON
      this.colsAmount = this.tovpilCrudService.extractColumns(data[0], undefined, this.colsFiAmount);
      // Asignar los datos al arreglo de productos
      this.dataAmount = data;
      // Asignar el número de filas por página dinámicamente
      this.rowsAmount = this.tovpilCrudService.calculateRowsPerPage(data.length, this.rowsAmount);
    } else {
      this.dataAmount = null;
      this.colsAmount = null;
      //this.handleError("Hubo un problema, no hay información que procesar en lista de guias. Por favor, recargue la página e inténtelo nuevamente más tarde.");
    }
  }

  /**
   * The function "handleSuccessLstGuide" handles the success response of a list of guides and extracts
   * the columns dynamically from the JSON data.
   * @param {any[]} data - An array of objects containing guide information.
   */
  async handleSuccessLstGuide(data: any[]) {
    if (data.length > 0) {
      // Extraer dinámicamente las columnas del JSON
      this.colsGuide = this.tovpilCrudService.extractColumns(data[0], undefined, this.colsFiGuide);
      this.colsGuide = await this.translationService.translateCols(this.colsGuide);
      // Asignar los datos al arreglo de productos
      this.dataGuide = data;
      // Asignar el número de filas por página dinámicamente
      // this.rowsGuide = this.tovpilCrudService.calculateRowsPerPage(data.length, this.rowsGuide);
    } else {
      this.dataGuide = null;
      this.colsGuide = null;
      //this.handleError("Hubo un problema, no hay información que procesar en lista de guias. Por favor, recargue la página e inténtelo nuevamente más tarde.");
    }
  }

  /**
   * The function "handleSuccessLstServe" handles the success response of a service call by extracting
   * columns from the JSON data, assigning the data to an array, and calculating the number of rows per
   * page.
   * @param {any[]} data - The parameter "data" is an array of objects.
   */
  async handleSuccessLstServe(data: any[]) {
    const language = this.globalUserPreferences?.preferences?.language || null;

    if (data.length > 0) {

      // Extraer dinámicamente las columnas del JSON
      await this.apiService.listCategoryTranslation({ language: language, fieldId: "weekDays" }).then(res => {
        this.lbl_sunday = res[0].value;
        this.lbl_monday = res[1].value;
        this.lbl_tuesday = res[2].value;
        this.lbl_wednesday = res[3].value;
        this.lbl_thursday = res[4].value;
        this.lbl_friday = res[5].value;
        this.lbl_saturday = res[6].value;
      });
      // Asignar los datos al arreglo de productos
      data = data.map((serve: any) => {
        let guideFull = serve.guiType.split("-", 2);
        return {
          ...serve,
          weekDays: serve.weekDays ?? " ",
          strDate: serve.strDate ?? " ",
          name: serve.guiType,
          guiType: guideFull[0]
        };
      });
      this.colsServ = this.tovpilCrudService.extractColumns(data[0], undefined, this.colsFiServ);
      this.dataServ = data;
      // Asignar el número de filas por página dinámicamente
      this.rowsServ = this.tovpilCrudService.calculateRowsPerPage(data.length, this.rowsServ);
    } else {
      this.dataServ = null;
      this.colsServ = null;
      //this.handleError("Hubo un problema, no hay información que procesar en lista de servicios. Por favor, recargue la página e inténtelo nuevamente más tarde.");
    }
  }

  /**
   * The function "handleSuccessLstSales" handles the success response of a sales list and extracts the
   * columns dynamically from the JSON data.
   * @param {any[]} data - An array of objects containing sales data.
   */
  async handleSuccessLstSales(data: any[]) {
    if (data.length > 0) {
      // Extraer dinámicamente las columnas del JSON
      this.colsSales = this.tovpilCrudService.extractColumns(data[0], undefined, this.colsFiSales);
      // Parse data 

      data = data.map((sale: any) => {
        const guideStrBal: string = sale['guideStrBal'] ?? "0";
        const guideNumBal: number = parseFloat(guideStrBal.replace(/,/g, ''));

        const saldoAnt = guideNumBal + (sale['lastSales'] ?? 0) - (sale['lastReturns'] ?? 0) - (sale['lastPayment'] ?? 0);
        const impPerio = (sale['currSales'] ?? 0) - (sale['currReturns'] ?? 0);
        const impPendi = ((saldoAnt ?? 0) + (impPerio ?? 0)) - (sale['currPayment'] ?? 0);

        return {
          ...sale,
          saldoAnt: saldoAnt.toFixed(2),
          impPerio: impPerio.toFixed(2),
          paymeDie: (sale['currPayment'] ?? 0).toFixed(2),
          impPendi: impPendi.toFixed(2),
          nvoImpPendo: '0.00', // Siempre mostrará 0.00
          canEdit: true
        };
      });

      data.push({
        guideId: " ",
        guideName: " TOTAL",
        guideLastName: " ",
        saldoAnt: data.reduce((total, item) => total + parseFloat(item?.saldoAnt || .00), .00).toFixed(2),
        impPerio: data.reduce((total, item) => total + parseFloat(item?.impPerio || .00), .00).toFixed(2),
        paymeDie: data.reduce((total, item) => total + parseFloat(item?.paymeDie || .00), .00).toFixed(2),
        impPendi: data.reduce((total, item) => total + parseFloat(item?.impPendi || .00), .00).toFixed(2),
        canEdit: false
      })

      // Asignar los datos al arreglo de productos
      this.dataSales = data;
      //console.debug("CX3 RCM - SALES CONS:  " + data.length);
      // Asignar el número de filas por página dinámicamente
      this.rowsSales = this.tovpilCrudService.calculateRowsPerPage(data.length, this.rowsSales);
    } else {
      this.dataSales = null;
      this.colsSales = null;
      //this.handleError("Hubo un problema, no hay información que procesar en lista de servicios. Por favor, recargue la página e inténtelo nuevamente más tarde.");
    }
  }

  /**
   * The function `formatDate` takes a string inputDate in the format "YYYYMMDD" and returns a formatted
   * date string in the format "DD / MM / YYYY".
   * @param {string} inputDate - The `inputDate` parameter is a string representing a date in the format
   * "YYYYMMDD".
   * @returns The formatDate function takes an inputDate string in the format "YYYYMMDD" and returns a
   * formatted date string in the format "DD / MM / YYYY".
   */
  formatDate(inputDate: string): string {
    const year = inputDate.substring(0, 4);
    const month = inputDate.substring(4, 6);
    const day = inputDate.substring(6, 8);
    const formattedDate = `${day} / ${month} / ${year}`;
    return formattedDate;
  }

  /**
   * This TypeScript function returns the name of the week day based on the provided number, with support
   * for multi-language labels.
   * @param {number | null} num - The `num` parameter in the `getWeekDay` function is a number that
   * represents a day of the week. It can range from 1 to 7, where 1 is Monday and 7 is Sunday. If `num`
   * is `null`, the function returns a dash ("-")
   * @returns If the input `num` is `null`, the function will return a dash symbol `" - "`. Otherwise, it
   * will return the corresponding weekday name based on the input number using the `weekDays` map. If
   * the input number does not match any key in the map, it will also return a dash symbol `" - "`.
   */
  getWeekDay(num: number | null): string {
    if (num == null) { // Utilizar el operador de igualdad débil
      return " - ";
    }

    const weekDays: Map<number, string> = new Map([
      // TODO: CHANGE LABELS TO MULTI LANGUAGE
      [7, this.lbl_sunday],
      [1, this.lbl_monday],
      [2, this.lbl_tuesday],
      [3, this.lbl_wednesday],
      [4, this.lbl_thursday],
      [5, this.lbl_friday],
      [6, this.lbl_saturday]
    ]);

    return weekDays.get(num) || " - ";
  }

  /**
   * The handleError function logs an error message to the console and adds an error message to the
   * message service.
   * @param {string} message - The `message` parameter is a string that represents the error message that
   * occurred while parsing.
   */
  async handleError(message: string) {
    console.error("An error occurred while parsing.");
    this.messageService.add({
      severity: 'warn',
      summary: 'Error',
      detail: message,
      life: 5000
    });
  }

  /**
 * The function "capitalizeLastElement" takes a string as input and returns the same string with the
 * last element capitalized.
 * @param {string} str - The parameter `str` is a string that represents the input string.
 * @returns the result of calling the `capitalizeLastElement` method of the `tovpilCrudService` object
 * with the `str` parameter.
 */
  capitalizeLastElement(str: string): string {
    return this.tovpilCrudService.capitalizeLastElement(str);
  }

  /**
   * The function `getNestedValue` retrieves a nested value from an object using a specified field.
   * @param {any} obj - The `obj` parameter is an object from which you want to retrieve a nested value.
   * @param {string} field - The `field` parameter is a string that represents the path to a nested value
   * in the `obj` object.
   * @returns The `getNestedValue` function is returning the value of the nested field in the given
   * object.
   */
  getNestedValue(obj: any, field: string): any {
    return this.tovpilCrudService.getNestedValue(obj, field);
  }

  /**
  * The `exportExcel()` function exports data to an Excel file if the data is not null and not empty,
  * otherwise it displays an error message.
  */
  exportExcel(_data: any[], _colsFilter: any[], _name: string) {
    if (_data === null) {
      this.messageService.add({
        severity: 'warn',
        summary: this.translations.lbl_no + ' ' + this.translations.lbl_information + ' ' + this.translations.lbl_to + ' ' + this.translations.lbl_process,
        life: 3000
      });
    } else if (_data.length < 1) {
      this.messageService.add({
        severity: 'warn',
        summary: this.translations.lbl_empty + ' ' + this.translations.lbl_list,
        life: 3000
      });
    } else {
      const filteredJSON = _data.map((item) => {
        const dynamicColumns = _colsFilter.map((col) => ({
          [col.name]: item ? this.tovpilCrudService.getNestedValue(item, col.value) || 'S/N' : 'S/N'
        }));
        return Object.assign({}, ...dynamicColumns);
      });
      this.filesService.tovpilExportXLSX(filteredJSON, _name);
    }
  }

  /**
   * The `exportPdf()` function exports data to a PDF file if the data is not null and the list is not
   * empty, otherwise it displays an error message.
   */
  exportPdf(_data: any[], _colsFilter: any[], _name: string) {
    if (_data === null) {
      this.messageService.add({
        severity: 'warn',
        summary: this.translations.lbl_no + ' ' + this.translations.lbl_information + ' ' + this.translations.lbl_to + ' ' + this.translations.lbl_process,
        life: 3000
      });
    } else if (_data.length < 1) {
      this.messageService.add({
        severity: 'warn',
        summary: this.translations.lbl_empty + ' ' + this.translations.lbl_list,
        life: 3000
      });
    } else {
      const filteredJSON = _data.map((item) => {
        const dynamicColumns = _colsFilter.map((col) => ({
          [col.name]: item ? this.tovpilCrudService.getNestedValue(item, col.value) || 'S/N' : 'S/N'
        }));
        return Object.assign({}, ...dynamicColumns);
      });
      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));
      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, _name);
    }
  }

  /**
   * The getTotal function calculates the total payment amount from an array of sales data.
   * @param {any[]} dataSales - The parameter `dataSales` is an array of objects. Each object represents
   * a sale and has a property `currPayment` which represents the current payment for that sale.
   * @returns the total sum of the "currPayment" property of each item in the "dataSales" array.
   */
  getTotalGuide(dataSales: any[]) {
    const total = dataSales.reduce((acc, item) => acc + parseFloat(item.impPendi || 0), 0);
    return (total.toFixed(2));
  }

  /**
   * The `getTotalAmount` function calculates the total amount from an array of sales data by summing up
   * the material values.
   * @param {any[]} dataSales - The `dataSales` parameter is an array of objects representing sales data.
   * Each object may contain a `material` property that represents the amount of material sold in that
   * particular sale. The `getTotalAmount` function calculates the total amount of material sold by
   * summing up the `material` values from
   * @returns The `getTotalAmount` function is returning the total amount calculated by summing up the
   * `material` values from each item in the `dataSales` array. If the `material` value is not a valid
   * number, it is treated as 0.
   */
  getTotalAmount(dataSales) {
    return dataSales[dataSales.length - 1]['total'] ?? 0;
  }

  /**
   * The function `validateEditSales` checks if the selected period for editing sales matches the current
   * year and the current period.
   * @returns The `validateEditSales()` function is returning a boolean value. It checks if the `year`
   * property of `this.selPeriod` is equal to the current year converted to a string, and if the `period`
   * property of `this.selPeriod` is equal to the calculated `period` value (either '1' or '2' based on
   * the current month). If both conditions are met
   */
  validateEditSales(): boolean {
    const currentYear: number = new Date().getFullYear();
    const currentMonth: number = new Date().getMonth() + 1;
    const selPeriod = this.globalUserPreferences?.preferences?.periodSelected?.period || null;
    const selYear = this.globalUserPreferences?.preferences?.periodSelected?.year || null;

    let period: string;

    if (currentMonth >= 1 && currentMonth <= 6) {
      period = '1';
    } else {
      period = '2';
    }

    return selYear === currentYear.toString() && selPeriod === period;
  }

  /**
   * The function onRowEditInit takes a parameter fiiLanguage of type any.
   * @param {any} fiiLanguage - The parameter `fiiLanguage` appears to be of type `any`, which means it
   * can hold any type of value. In the context of the function `onRowEditInit`, `fiiLanguage` likely
   * represents some language-related information or configuration. You can use this parameter to perform
   * actions or
   */
  onRowEditInit(fiiLanguage: any) {
    // NOTHING TO DO
  }

  /**
   * The function `onRowEditSave` logs the JSON stringified version of the `commentsf` object when
   * called.
   * @param {any} commentsf - The `commentsf` parameter in the `onRowEditSave` function seems to be
   * an object that contains language-related information. When the function is called, it logs a message
   * indicating that it will edit the `commentsf` object by stringifying it and outputting the result
   * to the
   */
  async onRowEditSave(commentsf: any) {
    ////console.log("Editará: ", JSON.stringify(commentsf));
    try {
      this.blocked = true;

      // VALIDATION
      if (commentsf['guideId'] === null || commentsf['guideId'] === undefined ||
        commentsf['nvoImpPendo'] === null || commentsf['nvoImpPendo'] === undefined || commentsf['nvoImpPendo'] <= 0) {
        this.messageService.add({
          severity: 'warn',
          summary: this.translations.lbl_accRec_Guides_Loc + ':' + this.translations.lbl_material_payment + ' ' + this.translations.lbl_die,
          detail: this.translations.lbl_cancelled + ' ' + this.translations.lbl_update + ', ' + this.translations.lbl_insert + ' ' + this.translations.lbl_valid + ' ' + this.translations.lbl_value
        });
        return;
      }

      // BUSSINESS LOGIC:  ((lastSales + lastReturns + currSales + currReturns) - (currPayment + lastPayment))
      const result = await this.tovpilCrudService.fetch(this.endPointSavePendAmount, {
        "id": commentsf['guideId'] ?? null,
        "field01": commentsf['lastSales'] ?? 0.0,
        "field02": commentsf['lastReturns'] ?? 0.0,
        "field03": commentsf['currSales'] ?? 0.0,
        "field04": commentsf['currReturns'] ?? 0.0,
        "field05": commentsf['currPayment'] ?? 0.0,
        "field06": commentsf['lastPayment'] ?? 0.0,
        "field07": commentsf['nvoImpPendo'] ?? 0.0,
      });
      if (result.success && result.data['comments'] !== 'ERROR') {
        this.messageService.add({ severity: 'success', summary: this.translations.lbl_accRec_Guides_Loc + ':' + this.translations.lbl_material_payment + ' ' + this.translations.lbl_die, detail: this.translations.lbl_updated_data });
        this.reloadGetListSales();
      } else {
        console.error("An error occurred onRowEditSave", result);
        this.messageService.add({
          severity: 'warn',
          summary: this.translations.lbl_accRec_Guides_Loc + ':' + this.translations.lbl_material_payment + ' ' + this.translations.lbl_die,
          detail: this.translations.lbl_cancelled + ' ' + this.translations.lbl_update + ', ' + this.translations.lbl_try + ' ' + this.translations.lbl_later
        });
      }
    } catch (error) {
      console.error("An error occurred onRowEditSave:", error);
      this.blocked = false;
      this.messageService.add({
        severity: 'warn',
        summary: this.translations.lbl_accRec_Guides_Loc + ':' + this.translations.lbl_material_payment + ' ' + this.translations.lbl_die,
        detail: this.translations.lbl_cancelled + ' ' + this.translations.lbl_update + ', ' + this.translations.lbl_try + ' ' + this.translations.lbl_later
      });
    } finally {
      setTimeout(() => {
        this.blocked = false;
      }, 1500);
    }
  }

  /**
   * The function onRowEditCancel takes a parameter fiiLanguage and does not have any implementation.
   * @param {any} fiiLanguage - The `fiiLanguage` parameter in the `onRowEditCancel` function appears to
   * be of type `any`, which means it can hold any type of value (string, number, object, etc.). You can
   * use this parameter to access the language information related to the row being edited when the
   */
  onRowEditCancel(fiiLanguage: any) {
    // NOTHING TO DO
  }

  /**
   * The function `redirectToLocMatLstM` asynchronously redirects to a specific page with navigation
   * extras based on the provided rowData.
   * @param {any} rowData - The `redirectToLocMatLstM` function is an asynchronous function that takes
   * `rowData` as a parameter. This function is responsible for redirecting to a specific location in
   * your application with certain navigation parameters.
   */
  async redirectToLocMatLstM(rowData: any) {
    try {

      let queryParams = {
        guideId: rowData['guideId'],
        type: (this.globalUserDataForm.get('selectedGuide').value)?.fieldVal ?? null
      };

      //console.debug("CX3 RCM - REDIRECT: " + queryParams);
      try {

        let stringRedirect = '/treasurer/locMatCtlLstM';
        const url = this.urlBuilderService.buildUrl(stringRedirect, queryParams);

        // Navegas a la ruta deseada con los parámetros de consulta
        this.router.navigateByUrl(url);
      } catch (navigationError) {
        console.error("An error occurred while navigating to coordination catalog details:", navigationError);
        this.messageService.add({ severity: 'warn', summary: this.translations.lbl_material_payment_registry_Loc, detail: Constants.SUCCESS_MESSAGE, life: 5000 });
      }
    } catch (parseError) {
      console.error("An error occurred while parsing state to JSON:", parseError);
      this.messageService.add({ severity: 'warn', summary: this.translations.lbl_material_payment_registry_Loc, detail: Constants.SUCCESS_MESSAGE, life: 5000 });
    }
  }

  /**
   * The goBack function closes the current window.
   */
  async goBack() {

    try {
      let queryParams = {
        module: 'treasurer',
        view: 'locMatCtlLst',
        forLevelId: 'L'
      };

      let stringRedirect = '/commons/lcSelector';

      const url = this.urlBuilderService.buildUrl(stringRedirect, queryParams);

      // Navegas a la ruta deseada con los parámetros de consulta
      this.router.navigateByUrl(url);
    } catch (error) {
      console.error("An error occurred while navigating:", error);
      //this.handleError('Redirigir a CX4', 'Algo salió mal al redirigir a CX4');
    }
  }

  /** MANAGE PREFERENCES */

  /**
   * The `onChangeUserPreferences` function updates user preferences including language, period, and
   * currency, and then updates the user preferences entity, cookie, and triggers a reload.
   */
  async onChangeUserPreferences() {

    //console.debug("CX3 RCM - ON CHANGE USER PREFERENCES: ")
    await this.refreshPreferences();

    // RECARGA
    this.initConfigs();
    this.getLanguages();
  }

  /* The above TypeScript code is updating properties of a user object, specifically setting the
      languageId, currencyId, periodYear, and periodMonth based on the provided values or null if not
      provided. It also updates the periodSelected property with the provided period value. Finally,
      it updates a cookie named "userPreferences" with the updated globalUserPreferences object using
      a cookie service. */
  async refreshPreferences() {
    // SOLO SE ACTUALIZA LA COOKIE
    let language = (this.globalUserDataForm.get('selectedLanguage').value)?.valueId || null;
    let period = (this.globalUserDataForm.get('selectedPeriod').value) || null;
    let currency = (this.globalUserDataForm.get('selectedCurrency').value)?.valueId || null;

    // ACTUALIZAMOS PROPIEDADES DE USUARIO
    this.userPreferencesService.updateTovpilCookie(
      null, // _levelId
      null, //_userId
      null, //_storeId
      null, //_id
      language || null, //_language
      currency || null, //_selCurrency
      null, //_coordinationId
      null, //_coordinationStack
      period?.year || null, //_selYear
      period?.period || null, //_selPeriod
      null, //_device
      null, //_storeSelected
      period, //_periodSelected
      null //_stores
    );
  }
}
